import React, {useEffect, useState} from 'react';
import {OfferForm} from "@offer/components";
import {OfferRequestType, OfferType} from "@offer/types/offer.types";
import {useParams} from "react-router-dom";
import {Maybe} from "@src/types/global.types";
import {getOffer, updateOffer} from "@offer/utils/axios";
import {AxiosResponse} from "axios";
import {Col, Row} from "react-bootstrap";

const OfferEditView = () => {
    const { id: offerId } = useParams();
    const [offer, setOffer] = useState<Maybe<OfferType>>();

    useEffect(() => {
        getOffer(offerId).then((offer: OfferType) => setOffer(offer))
    }, []);

    const saveOffer = async (data: OfferRequestType): Promise<AxiosResponse> => {
        return updateOffer(offer.id, data);
    }

    if (!offer) {
        return null;
    }

    return (
        <>
            <div className="page-header">
                <Row className="row g-2 align-items-center">
                    <Col className="col">
                        <div className="page-pretitle">
                            Oferty / Edycja
                        </div>
                        <h2 className="page-title">
                            {offer.title}
                        </h2>
                    </Col>
                </Row>
            </div>

            <div className="page-body">
                <OfferForm offer={offer} saveOffer={saveOffer} />
            </div>
        </>
    );
}

export default OfferEditView;